export abstract class AppSettings {
    static ApiServiceUrl = process.env.REACT_APP_API_URL;
    static LocalStorageTokenName = process.env.REACT_APP_LOCAL_STORAGE_TOKEN_NAME;
}